import { Heading, HStack, Text, Box, Icon, Button } from '@medely/ui-kit';
import React from 'react';
import { ContentLoader } from '@mp/components/ContentLoader';
import useDialog from '@mp/hooks/useDialog';
import { useEducationsForResumeBuilder } from './graphql';
import { EducationModal } from './educationModal/EducationModal';
import { usePlatform } from '@mp/hooks/usePlatform';
import { useProNavigate } from '@mp/contexts/NavigationContext';
import { useNoOutlineWrapper } from '@mp/components/AssignmentFavoriteButton/useNoOutlineWrapper';
import { EducationItem } from './educationItem/EducationItem';

export const Education = () => {
  const platform = usePlatform();
  const { navigate } = useProNavigate();
  const { isLoading, educations } = useEducationsForResumeBuilder();
  const { open, closeDialog, openDialog } = useDialog();
  const isWeb = platform === 'web';
  const { wrapWithNoOutline } = useNoOutlineWrapper('education-add-button', isWeb);

  const trigger = (
    <Button
      variant="text"
      color="primary"
      onClick={() => {
        if (isWeb) {
          openDialog();
        } else {
          (navigate as any)('EducationForm');
        }
      }}
      testId="education-button"
      startIcon={<Icon name="plus" variant="custom" color="state.teal.secondary" iconSize="16px" />}
    >
      Add
    </Button>
  );

  return (
    <Box pb={2} testId="education">
      <HStack alignItems="center" justifyContent="space-between">
        <Heading size="s">Education</Heading>
        {isWeb ? wrapWithNoOutline(trigger) : trigger}
      </HStack>
      <Box mb={0.5} />
      <Text size="l" color="text.secondary">
        Add your degree and/or certifications.
      </Text>
      <Box mb={0.5} />
      <ContentLoader loading={isLoading}>
        <>
          {educations?.map((education) => (
            <EducationItem key={education.id} educationItem={education} />
          ))}
        </>
      </ContentLoader>
      {isWeb && <EducationModal open={open} onClose={closeDialog} />}
    </Box>
  );
};
